import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-property.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
var _excluded = ["type"];
import "regenerator-runtime/runtime.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.typed-array.float32-array.js";
import "core-js/modules/es.typed-array.float64-array.js";
import "core-js/modules/es.typed-array.int32-array.js";
import "core-js/modules/es.typed-array.uint32-array.js";
import "core-js/modules/es.typed-array.uint16-array.js";
import "core-js/modules/es.typed-array.int16-array.js";
import "core-js/modules/es.typed-array.int8-array.js";
import "core-js/modules/es.typed-array.uint8-clamped-array.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.get-own-property-names.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.weak-set.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
import { _optionalChain } from '@sentry/core';
import { defineIntegration } from '@sentry/core';
var NodeType;
(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));
function elementClassMatchesRegex(el, regex) {
  for (var eIndex = el.classList.length; eIndex--;) {
    var className = el.classList[eIndex];
    if (regex.test(className)) {
      return true;
    }
  }
  return false;
}
function distanceToMatch(node, matchPredicate) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var distance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (!node) return -1;
  if (node.nodeType !== node.ELEMENT_NODE) return -1;
  if (distance > limit) return -1;
  if (matchPredicate(node)) return distance;
  return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
  return function (node) {
    var el = node;
    if (el === null) return false;
    try {
      if (className) {
        if (typeof className === 'string') {
          if (el.matches(".".concat(className))) return true;
        } else if (elementClassMatchesRegex(el, className)) {
          return true;
        }
      }
      if (selector && el.matches(selector)) return true;
      return false;
    } catch (e2) {
      return false;
    }
  };
}
var DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' + '\r\n' + 'now you can use replayer.getMirror() to access the mirror instance of a replayer,' + '\r\n' + 'or you can use record.mirror to access the mirror instance during recording.';
var _mirror = {
  map: {},
  getId: function getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },
  getNode: function getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },
  removeNodeFromMap: function removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },
  has: function has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },
  reset: function reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get: function get(target, prop, receiver) {
      if (prop === 'map') {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }
      return Reflect.get(target, prop, receiver);
    }
  });
}
function hookSetter(target, key, d, isRevoked) {
  var win = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window;
  var original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(target, key, isRevoked ? d : {
    set: function set(value) {
      var _this = this;
      setTimeout(function () {
        d.set.call(_this, value);
      }, 0);
      if (original && original.set) {
        original.set.call(this, value);
      }
    }
  });
  return function () {
    return hookSetter(target, key, original || {}, true);
  };
}
function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return function () {};
    }
    var original = source[name];
    var wrapped = replacement(original);
    if (typeof wrapped === 'function') {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }
    source[name] = wrapped;
    return function () {
      source[name] = original;
    };
  } catch (e2) {
    return function () {};
  }
}
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) ;
function closestElementOfNode(node) {
  if (!node) {
    return null;
  }
  var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
  return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
  if (!node) {
    return false;
  }
  var el = closestElementOfNode(node);
  if (!el) {
    return false;
  }
  var blockedPredicate = createMatchPredicate(blockClass, blockSelector);
  var blockDistance = distanceToMatch(el, blockedPredicate);
  var unblockDistance = -1;
  if (blockDistance < 0) {
    return false;
  }
  if (unblockSelector) {
    unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
  }
  if (blockDistance > -1 && unblockDistance < 0) {
    return true;
  }
  return blockDistance < unblockDistance;
}
var cachedImplementations = {};
function getImplementation(name) {
  var cached = cachedImplementations[name];
  if (cached) {
    return cached;
  }
  var document = window.document;
  var impl = window[name];
  if (document && typeof document.createElement === 'function') {
    try {
      var sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      var contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = contentWindow[name];
      }
      document.head.removeChild(sandbox);
    } catch (e) {}
  }
  return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame() {
  return getImplementation('requestAnimationFrame').apply(void 0, arguments);
}
function setTimeout() {
  return getImplementation('setTimeout').apply(void 0, arguments);
}
var CanvasContext = /* @__PURE__ */function (CanvasContext2) {
  CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
  CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
  CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
  return CanvasContext2;
}(CanvasContext || {});
var errorHandler;
function registerErrorHandler(handler) {
  errorHandler = handler;
}
var callbackWrapper = function callbackWrapper(cb) {
  if (!errorHandler) {
    return cb;
  }
  var rrwebWrapped = function rrwebWrapped() {
    try {
      return cb.apply(void 0, arguments);
    } catch (error) {
      if (errorHandler && errorHandler(error) === true) {
        return function () {};
      }
      throw error;
    }
  };
  return rrwebWrapped;
};

/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}
var encode = function encode(arraybuffer) {
  var bytes = new Uint8Array(arraybuffer),
    i,
    len = bytes.length,
    base64 = '';
  for (i = 0; i < len; i += 3) {
    base64 += chars[bytes[i] >> 2];
    base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
    base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
    base64 += chars[bytes[i + 2] & 63];
  }
  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + '=';
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + '==';
  }
  return base64;
};
var canvasVarMap = new Map();
function variableListFor(ctx, ctor) {
  var contextMap = canvasVarMap.get(ctx);
  if (!contextMap) {
    contextMap = new Map();
    canvasVarMap.set(ctx, contextMap);
  }
  if (!contextMap.has(ctor)) {
    contextMap.set(ctor, []);
  }
  return contextMap.get(ctor);
}
var saveWebGLVar = function saveWebGLVar(value, win, ctx) {
  if (!value || !(isInstanceOfWebGLObject(value, win) || _typeof(value) === 'object')) return;
  var name = value.constructor.name;
  var list = variableListFor(ctx, name);
  var index = list.indexOf(value);
  if (index === -1) {
    index = list.length;
    list.push(value);
  }
  return index;
};
function serializeArg(value, win, ctx) {
  if (value instanceof Array) {
    return value.map(function (arg) {
      return serializeArg(arg, win, ctx);
    });
  } else if (value === null) {
    return value;
  } else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
    var name = value.constructor.name;
    return {
      rr_type: name,
      args: [Object.values(value)]
    };
  } else if (value instanceof ArrayBuffer) {
    var _name = value.constructor.name;
    var base64 = encode(value);
    return {
      rr_type: _name,
      base64: base64
    };
  } else if (value instanceof DataView) {
    var _name2 = value.constructor.name;
    return {
      rr_type: _name2,
      args: [serializeArg(value.buffer, win, ctx), value.byteOffset, value.byteLength]
    };
  } else if (value instanceof HTMLImageElement) {
    var _name3 = value.constructor.name;
    var src = value.src;
    return {
      rr_type: _name3,
      src: src
    };
  } else if (value instanceof HTMLCanvasElement) {
    var _name4 = 'HTMLImageElement';
    var _src = value.toDataURL();
    return {
      rr_type: _name4,
      src: _src
    };
  } else if (value instanceof ImageData) {
    var _name5 = value.constructor.name;
    return {
      rr_type: _name5,
      args: [serializeArg(value.data, win, ctx), value.width, value.height]
    };
  } else if (isInstanceOfWebGLObject(value, win) || _typeof(value) === 'object') {
    var _name6 = value.constructor.name;
    var index = saveWebGLVar(value, win, ctx);
    return {
      rr_type: _name6,
      index: index
    };
  }
  return value;
}
var serializeArgs = function serializeArgs(args, win, ctx) {
  return args.map(function (arg) {
    return serializeArg(arg, win, ctx);
  });
};
var isInstanceOfWebGLObject = function isInstanceOfWebGLObject(value, win) {
  var webGLConstructorNames = ['WebGLActiveInfo', 'WebGLBuffer', 'WebGLFramebuffer', 'WebGLProgram', 'WebGLRenderbuffer', 'WebGLShader', 'WebGLShaderPrecisionFormat', 'WebGLTexture', 'WebGLUniformLocation', 'WebGLVertexArrayObject', 'WebGLVertexArrayObjectOES'];
  var supportedWebGLConstructorNames = webGLConstructorNames.filter(function (name) {
    return typeof win[name] === 'function';
  });
  return Boolean(supportedWebGLConstructorNames.find(function (name) {
    return value instanceof win[name];
  }));
};
function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
  var handlers = [];
  var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
  var _iterator = _createForOfIteratorHelper(props2D),
    _step;
  try {
    var _loop = function _loop() {
      var prop = _step.value;
      try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') {
          return "continue";
        }
        var restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
          return function () {
            var _this2 = this;
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
              setTimeout(function () {
                var recordArgs = serializeArgs(args, win, _this2);
                cb(_this2.canvas, {
                  type: CanvasContext['2D'],
                  property: prop,
                  args: recordArgs
                });
              }, 0);
            }
            return original.apply(this, args);
          };
        });
        handlers.push(restoreHandler);
      } catch (e) {
        var hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
          set: function set(v) {
            cb(this.canvas, {
              type: CanvasContext['2D'],
              property: prop,
              args: [v],
              setter: true
            });
          }
        });
        handlers.push(hookHandler);
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}
function getNormalizedContextName(contextType) {
  return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
  var handlers = [];
  try {
    var restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
      return function (contextType) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        if (!isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
          var ctxName = getNormalizedContextName(contextType);
          if (!('__context' in this)) this.__context = ctxName;
          if (setPreserveDrawingBufferToTrue && ['webgl', 'webgl2'].includes(ctxName)) {
            if (args[0] && _typeof(args[0]) === 'object') {
              var contextAttributes = args[0];
              if (!contextAttributes.preserveDrawingBuffer) {
                contextAttributes.preserveDrawingBuffer = true;
              }
            } else {
              args.splice(0, 1, {
                preserveDrawingBuffer: true
              });
            }
          }
        }
        return original.apply(this, [contextType].concat(args));
      };
    });
    handlers.push(restoreHandler);
  } catch (e) {
    console.error('failed to patch HTMLCanvasElement.prototype.getContext');
  }
  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}
function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
  var handlers = [];
  var props = Object.getOwnPropertyNames(prototype);
  var _iterator2 = _createForOfIteratorHelper(props),
    _step2;
  try {
    var _loop2 = function _loop2() {
      var prop = _step2.value;
      if (['isContextLost', 'canvas', 'drawingBufferWidth', 'drawingBufferHeight'].includes(prop)) {
        return "continue";
      }
      try {
        if (typeof prototype[prop] !== 'function') {
          return "continue";
        }
        var restoreHandler = patch(prototype, prop, function (original) {
          return function () {
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }
            var result = original.apply(this, args);
            saveWebGLVar(result, win, this);
            if ('tagName' in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
              var recordArgs = serializeArgs(args, win, this);
              var mutation = {
                type: type,
                property: prop,
                args: recordArgs
              };
              cb(this.canvas, mutation);
            }
            return result;
          };
        });
        handlers.push(restoreHandler);
      } catch (e) {
        var hookHandler = hookSetter(prototype, prop, {
          set: function set(v) {
            cb(this.canvas, {
              type: type,
              property: prop,
              args: [v],
              setter: true
            });
          }
        });
        handlers.push(hookHandler);
      }
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ret2 = _loop2();
      if (_ret2 === "continue") continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
  var handlers = [];
  handlers.push.apply(handlers, _toConsumableArray(patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win)));
  if (typeof win.WebGL2RenderingContext !== 'undefined') {
    handlers.push.apply(handlers, _toConsumableArray(patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win)));
  }
  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}
var r = "for(var e=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",t=\"undefined\"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s=\"\";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+\"=\":r%3==1&&(s=s.substring(0,s.length-2)+\"==\"),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!(\"OffscreenCanvas\"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+\"-\"+t;if(\"OffscreenCanvas\"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext(\"2d\");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return\"\"}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext(\"bitmaprenderer\"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:\"low\"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};";
function t() {
  var t = new Blob([r]);
  return URL.createObjectURL(t);
}
var CanvasManager = /*#__PURE__*/function () {
  function CanvasManager(options) {
    var _this3 = this;
    _classCallCheck(this, CanvasManager);
    this.pendingCanvasMutations = new Map();
    this.rafStamps = {
      latestId: 0,
      invokeId: null
    };
    this.shadowDoms = new Set();
    this.windowsSet = new WeakSet();
    this.windows = [];
    this.restoreHandlers = [];
    this.frozen = false;
    this.locked = false;
    this.snapshotInProgressMap = new Map();
    this.worker = null;
    this.processMutation = function (target, mutation) {
      var newFrame = _this3.rafStamps.invokeId && _this3.rafStamps.latestId !== _this3.rafStamps.invokeId;
      if (newFrame || !_this3.rafStamps.invokeId) _this3.rafStamps.invokeId = _this3.rafStamps.latestId;
      if (!_this3.pendingCanvasMutations.has(target)) {
        _this3.pendingCanvasMutations.set(target, []);
      }
      _this3.pendingCanvasMutations.get(target).push(mutation);
    };
    var _options$sampling = options.sampling,
      sampling = _options$sampling === void 0 ? 'all' : _options$sampling,
      win = options.win,
      blockClass = options.blockClass,
      blockSelector = options.blockSelector,
      unblockSelector = options.unblockSelector,
      maxCanvasSize = options.maxCanvasSize,
      recordCanvas = options.recordCanvas,
      dataURLOptions = options.dataURLOptions,
      errorHandler = options.errorHandler;
    this.mutationCb = options.mutationCb;
    this.mirror = options.mirror;
    this.options = options;
    if (errorHandler) {
      registerErrorHandler(errorHandler);
    }
    if (recordCanvas && typeof sampling === 'number' || options.enableManualSnapshot) {
      this.worker = this.initFPSWorker();
    }
    this.addWindow(win);
    if (options.enableManualSnapshot) {
      return;
    }
    callbackWrapper(function () {
      if (recordCanvas && sampling === 'all') {
        _this3.startRAFTimestamping();
        _this3.startPendingCanvasMutationFlusher();
      }
      if (recordCanvas && typeof sampling === 'number') {
        _this3.initCanvasFPSObserver(sampling, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
          dataURLOptions: dataURLOptions
        });
      }
    })();
  }
  _createClass(CanvasManager, [{
    key: "reset",
    value: function reset() {
      this.pendingCanvasMutations.clear();
      this.restoreHandlers.forEach(function (handler) {
        try {
          handler();
        } catch (e) {}
      });
      this.restoreHandlers = [];
      this.windowsSet = new WeakSet();
      this.windows = [];
      this.shadowDoms = new Set();
      _optionalChain([this, 'access', function (_) {
        return _.worker;
      }, 'optionalAccess', function (_2) {
        return _2.terminate;
      }, 'call', function (_3) {
        return _3();
      }]);
      this.worker = null;
      this.snapshotInProgressMap = new Map();
    }
  }, {
    key: "freeze",
    value: function freeze() {
      this.frozen = true;
    }
  }, {
    key: "unfreeze",
    value: function unfreeze() {
      this.frozen = false;
    }
  }, {
    key: "lock",
    value: function lock() {
      this.locked = true;
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.locked = false;
    }
  }, {
    key: "addWindow",
    value: function addWindow(win) {
      var _this4 = this;
      var _this$options = this.options,
        _this$options$samplin = _this$options.sampling,
        sampling = _this$options$samplin === void 0 ? 'all' : _this$options$samplin,
        blockClass = _this$options.blockClass,
        blockSelector = _this$options.blockSelector,
        unblockSelector = _this$options.unblockSelector,
        recordCanvas = _this$options.recordCanvas,
        enableManualSnapshot = _this$options.enableManualSnapshot;
      if (this.windowsSet.has(win)) return;
      if (enableManualSnapshot) {
        this.windowsSet.add(win);
        this.windows.push(new WeakRef(win));
        return;
      }
      callbackWrapper(function () {
        if (recordCanvas && sampling === 'all') {
          _this4.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
        }
        if (recordCanvas && typeof sampling === 'number') {
          var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
          _this4.restoreHandlers.push(function () {
            canvasContextReset();
          });
        }
      })();
      this.windowsSet.add(win);
      this.windows.push(new WeakRef(win));
    }
  }, {
    key: "addShadowRoot",
    value: function addShadowRoot(shadowRoot) {
      this.shadowDoms.add(new WeakRef(shadowRoot));
    }
  }, {
    key: "resetShadowRoots",
    value: function resetShadowRoots() {
      this.shadowDoms = new Set();
    }
  }, {
    key: "initFPSWorker",
    value: function initFPSWorker() {
      var _this5 = this;
      var worker = new Worker(t());
      worker.onmessage = function (e) {
        var data = e.data;
        var id = data.id;
        _this5.snapshotInProgressMap.set(id, false);
        if (!('base64' in data)) return;
        var base64 = data.base64,
          type = data.type,
          width = data.width,
          height = data.height;
        _this5.mutationCb({
          id: id,
          type: CanvasContext['2D'],
          commands: [{
            property: 'clearRect',
            args: [0, 0, width, height]
          }, {
            property: 'drawImage',
            args: [{
              rr_type: 'ImageBitmap',
              args: [{
                rr_type: 'Blob',
                data: [{
                  rr_type: 'ArrayBuffer',
                  base64: base64
                }],
                type: type
              }]
            }, 0, 0, width, height]
          }]
        });
      };
      return worker;
    }
  }, {
    key: "initCanvasFPSObserver",
    value: function initCanvasFPSObserver(fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
      var rafId = this.takeSnapshot(false, fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
      this.restoreHandlers.push(function () {
        cancelAnimationFrame(rafId);
      });
    }
  }, {
    key: "initCanvasMutationObserver",
    value: function initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
      var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
      var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
      var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
      this.restoreHandlers.push(function () {
        canvasContextReset();
        canvas2DReset();
        canvasWebGL1and2Reset();
      });
    }
  }, {
    key: "snapshot",
    value: function snapshot(canvasElement) {
      var options = this.options;
      var rafId = this.takeSnapshot(true, options.sampling === 'all' ? 2 : options.sampling || 2, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
      this.restoreHandlers.push(function () {
        cancelAnimationFrame(rafId);
      });
    }
  }, {
    key: "takeSnapshot",
    value: function takeSnapshot(isManualSnapshot, fps, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
      var _this6 = this;
      var timeBetweenSnapshots = 1000 / fps;
      var lastSnapshotTime = 0;
      var rafId;
      var getCanvas = function getCanvas(canvasElement) {
        if (canvasElement) {
          return [canvasElement];
        }
        var matchedCanvas = [];
        var searchCanvas = function searchCanvas(root) {
          root.querySelectorAll('canvas').forEach(function (canvas) {
            if (!isBlocked(canvas, blockClass, blockSelector, unblockSelector)) {
              matchedCanvas.push(canvas);
            }
          });
        };
        var _iterator3 = _createForOfIteratorHelper(_this6.windows),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;
            var _window = item.deref();
            if (_window) {
              searchCanvas(_window.document);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var _iterator4 = _createForOfIteratorHelper(_this6.shadowDoms),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _item = _step4.value;
            var shadowRoot = _item.deref();
            if (shadowRoot) {
              searchCanvas(shadowRoot);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        return matchedCanvas;
      };
      var takeCanvasSnapshots = function takeCanvasSnapshots(timestamp) {
        if (!_this6.windows.length) {
          return;
        }
        if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
          rafId = onRequestAnimationFrame(takeCanvasSnapshots);
          return;
        }
        lastSnapshotTime = timestamp;
        getCanvas(canvasElement).forEach(function (canvas) {
          if (!_this6.mirror.hasNode(canvas)) {
            return;
          }
          var id = _this6.mirror.getId(canvas);
          if (_this6.snapshotInProgressMap.get(id)) return;
          if (!canvas.width || !canvas.height) return;
          _this6.snapshotInProgressMap.set(id, true);
          if (!isManualSnapshot && ['webgl', 'webgl2'].includes(canvas.__context)) {
            var context = canvas.getContext(canvas.__context);
            if (_optionalChain([context, 'optionalAccess', function (_4) {
              return _4.getContextAttributes;
            }, 'call', function (_5) {
              return _5();
            }, 'optionalAccess', function (_6) {
              return _6.preserveDrawingBuffer;
            }]) === false) {
              context.clear(context.COLOR_BUFFER_BIT);
            }
          }
          createImageBitmap(canvas).then(function (bitmap) {
            _optionalChain([_this6, 'access', function (_7) {
              return _7.worker;
            }, 'optionalAccess', function (_8) {
              return _8.postMessage;
            }, 'call', function (_9) {
              return _9({
                id: id,
                bitmap: bitmap,
                width: canvas.width,
                height: canvas.height,
                dataURLOptions: dataURLOptions,
                maxCanvasSize: maxCanvasSize
              }, [bitmap]);
            }]);
          }).catch(function (error) {
            callbackWrapper(function () {
              throw error;
            })();
          });
        });
        if (!isManualSnapshot) {
          rafId = onRequestAnimationFrame(takeCanvasSnapshots);
        }
      };
      rafId = onRequestAnimationFrame(takeCanvasSnapshots);
      return rafId;
    }
  }, {
    key: "startPendingCanvasMutationFlusher",
    value: function startPendingCanvasMutationFlusher() {
      var _this7 = this;
      onRequestAnimationFrame(function () {
        return _this7.flushPendingCanvasMutations();
      });
    }
  }, {
    key: "startRAFTimestamping",
    value: function startRAFTimestamping() {
      var _this8 = this;
      var setLatestRAFTimestamp = function setLatestRAFTimestamp(timestamp) {
        _this8.rafStamps.latestId = timestamp;
        onRequestAnimationFrame(setLatestRAFTimestamp);
      };
      onRequestAnimationFrame(setLatestRAFTimestamp);
    }
  }, {
    key: "flushPendingCanvasMutations",
    value: function flushPendingCanvasMutations() {
      var _this9 = this;
      this.pendingCanvasMutations.forEach(function (values, canvas) {
        var id = _this9.mirror.getId(canvas);
        _this9.flushPendingCanvasMutationFor(canvas, id);
      });
      onRequestAnimationFrame(function () {
        return _this9.flushPendingCanvasMutations();
      });
    }
  }, {
    key: "flushPendingCanvasMutationFor",
    value: function flushPendingCanvasMutationFor(canvas, id) {
      if (this.frozen || this.locked) {
        return;
      }
      var valuesWithType = this.pendingCanvasMutations.get(canvas);
      if (!valuesWithType || id === -1) return;
      var values = valuesWithType.map(function (value) {
        var type = value.type,
          rest = _objectWithoutProperties(value, _excluded);
        return rest;
      });
      var type = valuesWithType[0].type;
      this.mutationCb({
        id: id,
        type: type,
        commands: values
      });
      this.pendingCanvasMutations.delete(canvas);
    }
  }]);
  return CanvasManager;
}();
var CANVAS_QUALITY = {
  low: {
    sampling: {
      canvas: 1
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.25
    }
  },
  medium: {
    sampling: {
      canvas: 2
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.4
    }
  },
  high: {
    sampling: {
      canvas: 4
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.5
    }
  }
};
var INTEGRATION_NAME = 'ReplayCanvas';
var DEFAULT_MAX_CANVAS_SIZE = 1280;

/** Exported only for type safe tests. */
var _replayCanvasIntegration = function _replayCanvasIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = options.maxCanvasSize || [],
    _ref2 = _slicedToArray(_ref, 2),
    maxCanvasWidth = _ref2[0],
    maxCanvasHeight = _ref2[1];
  var _canvasOptions = {
    quality: options.quality || 'medium',
    enableManualSnapshot: options.enableManualSnapshot,
    maxCanvasSize: [maxCanvasWidth ? Math.min(maxCanvasWidth, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE, maxCanvasHeight ? Math.min(maxCanvasHeight, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE]
  };
  var canvasManagerResolve;
  var _canvasManager = new Promise(function (resolve) {
    return canvasManagerResolve = resolve;
  });
  return {
    name: INTEGRATION_NAME,
    getOptions: function getOptions() {
      var quality = _canvasOptions.quality,
        enableManualSnapshot = _canvasOptions.enableManualSnapshot,
        maxCanvasSize = _canvasOptions.maxCanvasSize;
      return _objectSpread({
        enableManualSnapshot: enableManualSnapshot,
        recordCanvas: true,
        getCanvasManager: function getCanvasManager(getCanvasManagerOptions) {
          var manager = new CanvasManager(_objectSpread(_objectSpread({}, getCanvasManagerOptions), {}, {
            enableManualSnapshot: enableManualSnapshot,
            maxCanvasSize: maxCanvasSize,
            errorHandler: function errorHandler(err) {
              try {
                if (_typeof(err) === 'object') {
                  err.__rrweb__ = true;
                }
              } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
              }
            }
          }));
          canvasManagerResolve(manager);
          return manager;
        }
      }, CANVAS_QUALITY[quality || 'medium'] || CANVAS_QUALITY.medium);
    },
    snapshot: function snapshot(canvasElement) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var canvasManager;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _canvasManager;
            case 2:
              canvasManager = _context.sent;
              canvasManager.snapshot(canvasElement);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  };
};

/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */
var replayCanvasIntegration = defineIntegration(_replayCanvasIntegration);
export { replayCanvasIntegration };